import { render } from "./App.vue?vue&type=template&id=510e0758"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=510e0758&lang=css"

import exportComponent from "/builds/haut.ai-team/haut.ai-team/liqa/ecom/stands/clients-iframe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__